import { AdminPage } from './pages/AdminPage';
import { DashboardPage } from './pages/DashboardPage';
import { StartupGate } from './pages/StartupGate';
import { SessionProvider } from './session/SessionProvider';
import { ThemeModeProvider } from './theme/ThemeModeProvider';
import { WeatherProvider } from './weather/WeatherProvider';

/**
 * Aplicația are două pagini și nicio navigare între ele, deci nu merită un
 * router: calea se citește o dată, la pornire. Nginx întoarce oricum
 * `index.html` pentru orice cale (`try_files … /index.html`), deci `/admin`
 * ajunge aici fără nicio configurare în plus.
 */
function isAdminRoute(): boolean {
  const base = import.meta.env.BASE_URL.replace(/\/+$/, '');
  return window.location.pathname.replace(/\/+$/, '') === `${base}/admin`;
}

export default function App() {
  // Adminul stă în afara `SessionProvider`, deliberat: nu cere bilet și nu
  // deschide socketul. E calea de recuperare — când cheia dashboardului e
  // greșită sau revocată, restul aplicației arată ecranul de mentenanță, și
  // exact atunci trebuie să poți intra aici ca să generezi alta.
  if (isAdminRoute()) {
    return (
      <ThemeModeProvider>
        <AdminPage />
      </ThemeModeProvider>
    );
  }

  return (
    <ThemeModeProvider>
      <SessionProvider>
        {/*
          Socket-ul stă deasupra porții, nu sub ea: așa continuă să încerce
          reconectarea cât timp se vede pagina de mentenanță, iar aplicația se
          întoarce singură când stația revine.
        */}
        <WeatherProvider>
          <StartupGate>
            <DashboardPage />
          </StartupGate>
        </WeatherProvider>
      </SessionProvider>
    </ThemeModeProvider>
  );
}
